import React, { useCallback, useEffect, useState } from 'react';
import actions from '@flux/action';
import { connect } from 'react-redux';
import { deepCopy } from '@utils/common';
import ApproachComponent from './approachComponent';
import { PopAlert } from 'appkit-react';
import { DEFALUT_PERMISSION_SECTION } from '@model';

/**
 * Wrapper for Integration Approach and Separation Approach page
 */
function ApproachWrapper({
  title,
  fetchService,
  saveService,
  projectId,
  changeLoading,
  insightSectionKey,
  ...props
}) {
  const fetchData = useCallback(
    async () => await fetchService(projectId),
    [projectId, fetchService],
  );

  const onSave = useCallback(
    async (data) => {
      const result = await saveService(projectId, data);
      if (result.message?.includes('successfully')) {
        setOriginData(deepCopy(data));
        PopAlert({
          className: 'success-message-popover',
          oneLineDisplay: true,
          duration: 2000,
          status: 'success',
          message: 'SAVED SUCCESSFULLY',
        });
      }
    },
    [projectId],
  );
  const [originData, setOriginData] = useState([]);

  useEffect(() => {
    if (!projectId || projectId === 'null') {
      return;
    }
    (async () => {
      changeLoading(true);
      try {
        const responseData = await fetchData();
        setOriginData(responseData);
      } catch (e) {
        console.warn(e);
      }
      changeLoading(false);
    })();
  }, [projectId]);

  return (
    <ApproachComponent
      originData={originData}
      onSave={onSave}
      insightSectionKey={insightSectionKey}
      {...props}
    />
  );
}

const mapDispatchToProps = (dispatch) => ({
  changeLoading(isLoading) {
    dispatch(actions.changeLoading(isLoading));
  },
});

const mapStateToProps = ({ common, projects, login }) => {
  const projectId = common.currentId;
  return {
    projectId,
    permission: projects.sectionsPermission.insightPermission,
    userInfo: login.userInfo || {},
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(React.memo(ApproachWrapper));
